// extracted by mini-css-extract-plugin
module.exports = {"container":"GoBackButton_container__ChdS8"};